import { Box, Container } from '@chakra-ui/react';
import React from 'react';

import styled from '@emotion/styled';

export const ContainerWrapper = styled.div`
  .Container {
    .open { z-index: 100; }
  }

  @media (max-width: 720px) {
    .Container {
      padding: 0;
    }
  }
`;

export interface CenteredLayoutProps {
  children: React.ReactChild;
}
export const CenteredLayout = (props: CenteredLayoutProps): JSX.Element => {
  const { children } = props;

  return (
    <Box >
      <ContainerWrapper>
        <Container maxW="container.xl" className={'Container'} pl={0} pr={0}>
          {children}
        </Container>
      </ContainerWrapper>
    </Box>
  );
};
